export default () => ({
  root: {
    '& [class*="HoiPoi__Label__root"]': {
      textAlign: 'left'
    },
    '& > [class*="formControl"]': {
      '& > [class*="InputWrapper__root"]': {
        '& > [class*="FieldBottom__root"]': {
          '& > [class*="FieldBottom__error"]': {
            textAlign: 'left'
          }
        }
      }
    }
  }
});